"use client";

import { useRef, type MouseEvent } from "react";

export default function Footer({ year }: { year: number }) {
  const legalRef = useRef<HTMLDialogElement>(null);
  const privacyRef = useRef<HTMLDialogElement>(null);
  function closeOnBackdrop(event: MouseEvent<HTMLDialogElement>) {
    if (event.target !== event.currentTarget) return;
    const box = event.currentTarget.getBoundingClientRect();
    if (
      event.clientX < box.left ||
      event.clientX > box.right ||
      event.clientY < box.top ||
      event.clientY > box.bottom
    )
      event.currentTarget.close();
  }
  return (
    <>
      <footer>
        <a className="brand" href="#oben">
          ALEX KRENN<span className="brand-dot"></span>
        </a>
        <span>
          © <span>{year}</span> Alex Krenn
        </span>
        <div>
          <button onClick={() => legalRef.current?.showModal()}>
            Impressum
          </button>
          <button onClick={() => privacyRef.current?.showModal()}>
            Datenschutz
          </button>
          <a href="#oben" aria-label="Nach oben">
            Nach oben ↑
          </a>
        </div>
      </footer>
      <dialog id="legal" ref={legalRef} onClick={closeOnBackdrop}>
        <button
          className="close"
          aria-label="Schließen"
          onClick={() => legalRef.current?.close()}
        >
          ×
        </button>
        <p className="eyebrow">RECHTLICHES</p>
        <h2>Impressum</h2>
        <p>
          Alexander Krenn
          <br />
          Brühlerstraße 79/3/3
          <br />
          2340 Mödling, Österreich
        </p>
        <p>
          Telefon: <a href="tel:+436767330621">+43 676 733 06 21</a>
          <br />
          E-Mail: <a href="mailto:alex.krenn@gmx.net">alex.krenn@gmx.net</a>
        </p>
        <p>
          FG Freizeit- und Sportbetriebe
          <br />
          Steuernummer: 136/3908
          <br />
          Kammer: Niederösterreichische Wirtschaftskammer
          <br />
          Aufsichtsbehörde: Bezirkshauptmannschaft Mödling
        </p>
      </dialog>
      <dialog id="privacy" ref={privacyRef} onClick={closeOnBackdrop}>
        <button
          className="close"
          aria-label="Schließen"
          onClick={() => privacyRef.current?.close()}
        >
          ×
        </button>
        <p className="eyebrow">RECHTLICHES</p>
        <h2>Datenschutz</h2>
        <p>
          Verantwortlich für die Inhalte: Alexander Krenn, Brühlerstraße 79/3/3,
          2340 Mödling. Kontakt: alex.krenn@gmx.net.
        </p>
        <p>
          Diese Homepage verwendet keine Analyse- oder Marketingdienste.
          Schriften und Bilder werden mit der Website ausgeliefert. Es werden
          durch den Seitencode keine Cookies gesetzt.
        </p>
        <p>
          Beim Aufruf können auf dem bereitstellenden Server technisch
          notwendige Verbindungsdaten zur Auslieferung der Website verarbeitet
          werden.
        </p>
        <p>
          Wenn du per E-Mail oder Telefon Kontakt aufnimmst, werden deine
          übermittelten Angaben zur Bearbeitung deiner Anfrage verwendet. Für
          Anliegen zur Verarbeitung deiner Daten kannst du dich an die oben
          genannte Kontaktadresse wenden.
        </p>
      </dialog>
    </>
  );
}
